module.exports = __webpack_public_path__ + "img/icon-credit-card.ce6abfea.svg";